import { createContext } from 'react';
const ToastContext = createContext({
    toasts: [],
    pushToast: () => 'undefined',
    pushRawToast: () => 'undefined',
    removeToast: () => undefined,
});
export default ToastContext;
//# sourceMappingURL=ToastContext.js.map